/**
 * File Browser Component
 *
 * This component require few properties as props:
 * 1. unique id => Id is required to associate child elements.
 * 2. onFileSelected() => Function which will trigger on file change.
 *
 * Other Optional fields are:
 * 1: fileType => list of file types allowed.
 * 2. enableNativeElement => This will enable native html element, by default set to false
 *
 * Child element need to be passed in order to render the the file upload element.
 * Child element can be anything valid html element except native button element.
 *
 *
 *
 *
 */

import React from "react";
import PropTypes from "prop-types";

const FileBrowser = (props) => {
  let className;
  if (props.enableNativeElement) {
    className = "display-block";
  } else {
    className = "display-none";
  }

  return (
    <div>
      <input
        type="file"
        className={className}
        id={props.id}
        data-testid={props.id}
        onChange={(e) => {
          if (e.target.files.length > 0) {
            props.onFileSelected(e.target.files[0]);
          }
        }}
        accept={props.fileType}
      />
      {props.enableNativeElement ? null : (
        <label htmlFor={props.id}>{props.children}</label>
      )}
    </div>
  );
};

FileBrowser.propTypes = {
  enableNativeElement: PropTypes.bool,
  id: PropTypes.string.isRequired,
  onFileSelected: PropTypes.func.isRequired,
  fileType: PropTypes.string,
  children: PropTypes.node,
};

FileBrowser.defaultProps = {
  enableNativeElement: false,
  fileType: undefined,
  children: null,
};

export default FileBrowser;
